import React from 'react';
import './GeneralInfoButtons.css';
import SubmitButton from '../SubmitButton/SubmitButton';
const GeneralInfoButtons = ({
  isFormChanged,
  isFormValid,
  onSave,
  onCancel,
  deleteDisabled = false,
  isLoadingFormData,
  isLoadingCancelEdit,
}) => {
  return (
    <div className='general-info-buttons'>
      <SubmitButton
        text='Сохранить'
        disabled={!isFormChanged || !isFormValid}
        type='submit'
        onClick={onSave}
        className='my-orgs-tab__button'
        isLoading={isLoadingFormData}
        id='save'
      />

      {/* Кнопка "Отменить" */}
      <SubmitButton
        text='Отменить'
        disabled={!isFormChanged}
        type='button'
        onClick={onCancel}
        isLoading={isLoadingCancelEdit}
        className='my-orgs-tab__button my-orgs-tab__button_cancel'
      />
    </div>
  );
};

export default GeneralInfoButtons;
